import React, { useState, useEffect } from "react"
import { withTranslation } from "next-i18next"
import { useDispatch } from "react-redux"
import _get from "lodash/get"
import {
  getGenericListPath,
  showToast,
} from "@/store/features/genericSlice"
import { getConfig } from "@/constants/config"
import useTradeMembershipi18n from "@/i18n/useTradeMembershipi18n"

import TradeMembershipView from "./Trademembership.view"

const TradeMembership = props => {
  const { data: componentProp } = props
  const dispatch = useDispatch()
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [brandName, setBrandName] = useState("")
  const [legalPageLinks, setLegalPageLinks] = useState(null)
  const [teaserComponent, setTeaserComponent] = useState(null)

  useEffect(() => {
    getConfig().then(async config => {
      setBrandName(_get(config, "general.siteName", ""))
      setLegalPageLinks(_get(config, "legalPageData.map", {}))
    })
    dispatch(getGenericListPath())
    if (document?.getElementById?.("aem-lead-gen-container")) {
      setTeaserComponent(document?.getElementById?.("aem-lead-gen-container"))
    }
  }, [])
  const i18n = useTradeMembershipi18n(componentProp)
  const handleSubmit = status => {
    setSubmitSuccess(status)
  }
  const showToaster = msg => {
    dispatch(
      showToast({
        message: msg,
        isVisible: true,
      })
    )
  }
  
  return (
    <TradeMembershipView
      key={submitSuccess}
      i18n={i18n}
      submitSuccess={submitSuccess}
      legalPages={legalPageLinks}
      handleSubmitMsg={handleSubmit}
      continueShoppingUrl={props?.data?.ctalink ?? ""}
      showToaster={msg => showToaster(msg)}
      brandName={brandName?.toLowerCase()}
      isNewTab={props?.data?.isnewtab ?? false}
      teaserComponent={teaserComponent}
      termsAndConsLink={componentProp?.termsandconditionslink ?? ""}
    />
  )
}

export default withTranslation()(TradeMembership)
